import { CSSProperties, MouseEvent } from 'react'
import styled, { createGlobalStyle, css } from 'styled-components'
import { Icon, StrictIconProps, StrictPopupProps } from 'semantic-ui-react'

import Anchor from '@/ui/Anchor'

// @ts-ignore
Icon.propTypes = {}

export interface IconProps extends Pick<StrictIconProps, 'size'> {
  name: string
  color?: string
  title?: string
  noMargin?: boolean
  button?: boolean
  disabled?: boolean
  loading?: boolean
  onClick?: (e: MouseEvent) => void
  popupPosition?: StrictPopupProps['position']
  popupOffset?: StrictPopupProps['offset']
  style?: CSSProperties
  className?: string
  label?: string | number | null
}

export const GlobalStyle = createGlobalStyle`
  i.icon {
    font-size: 1.1em !important;

    &.small {
      font-size: 1em !important;
    }

    &.large {
      font-size: 1.25em !important;
    }
    
    &.big {
      font-size: 1.5em  !important;
    }

    &.verybig {
      font-size: 2em  !important;
    }

    &.huge {
      font-size: 4em !important;
    }

    &.massive {
      font-size: 6em !important;
    }
  }

  a > .icon {
    top: 3px
  }

  div:has(> .popup.no-pointer-events) {
    pointer-events: none;
  }
`

const labelShapes = {
  basic: 'BASIC',
  wide: 'WIDE',
}
export const StyledIcon = styled(
  ({ button, label, labelColor, labelTextColor, labelShape, ...props }) => (
    <Icon {...props} />
  ),
)`
  &&& {
    position: relative;
    color: ${props => props.color || '#012d3e'};
    cursor: ${props =>
      props.button && !props.disabled ? 'pointer' : 'initial'};
    margin: ${props => (props.noMargin ? 0 : '0 .25em 0 0')};

    ${({ theme, label, labelColor, labelTextColor, labelShape = 'wide' }) =>
      label &&
      `
      &:after {
        font-family: 'Roboto';
        background-color: ${labelColor ?? theme.colors.red};
        color: ${labelTextColor ?? '#fff'};
        border-radius: 10px;
        width: ${labelShapes[labelShape] === 'BASIC' ? '18px' : '23px'};
        border: 1px solid #fff;
        height: 18px;
        font-size: 9px;
        font-weight: 400;
        position: absolute;
        top: calc(50% - 1px);
        left: calc(50% - 1px);
        content: '${label}';
        line-height: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
      }
    `};
  }
`

export const VisibilityToggleWrapper = styled(Anchor)<{ toggled?: boolean }>`
  ${({ toggled }) =>
    toggled &&
    css`
      .icon:after {
        content: '/';
        font-family: helvetica;
        left: 7px;
        top: -3px;
        position: absolute;
        font-size: 21px;
        transform: rotate(35deg);
        color: gray;
      }
    `}
`
